/* eslint-disable */
// @ts-nocheck
import * as React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import Button from './Button';
import ModalPostbackTestingExit from '../../../main/components/ModalPostbackTestingExit';
type Props = {
  startText: string;
  expiredText: string;
  stopActionText: string;
  restartActionText: string;
  testid: string;
  timerValue: number;
  timerInterval: number;
  onStopCallback: () => void;
  onRestartCallback: () => void;
};
type State = {
  completed: boolean;
  pollCountTimer: number;
  timeLeft: string;
  isPostbackTestingExitModalOpen: boolean;
};

class Timer extends React.Component<Props, State> {
  // $FlowFixMe
  _poll;

  static defaultProps = {
    startText: 'This postback test session will stop after 10 minutes. You can end the session anytime.',
    expiredText: 'This postback test session has ended. You can re-start postback testing anytime.',
    stopActionText: 'End Postback testing',
    restartActionText: 'Start Postback testing',
    testid: 'timer',
    timerValue: 600,
    timerInterval: 1000,
  };

  state = {
    completed: false,
    pollCountTimer: this.props.timerValue,
    timeLeft: '10:00',
    isPostbackTestingExitModalOpen: false,
  };

  _getTimeLeft = (timerValue: number) => {
    return moment().startOf('day').seconds(timerValue).format('mm:ss');
  };

  _getTimerValue = () => {
    const timeLeft = this._getTimeLeft(this.state.pollCountTimer);

    this.setState({
      pollCountTimer: this.state.pollCountTimer - 1,
      timeLeft,
    });

    if (this._hasPollExpired()) {
      this._stopPolling();
    }
  };

  _hasPollExpired = () => {
    return this.state.pollCountTimer <= 0;
  };

  _resetPolling = () => {
    const { timerInterval } = this.props;
    this.setState({
      completed: false,
      pollCountTimer: this.props.timerValue,
      timeLeft: '10:00',
    });
    this.props.onRestartCallback();
    this._poll = setInterval(this._getTimerValue, timerInterval);
  };

  _stopPolling = () => {
    const timeLeft = this._getTimeLeft(this.props.timerValue);

    this.setState(
      {
        completed: true,
        pollCountTimer: 0,
        timeLeft,
      },
      clearInterval(this._poll)
    );
    this.props.onStopCallback();
  };

  _closeModal = () => {
    this.setState({
      isPostbackTestingExitModalOpen: false,
    });
  };

  _exitPostbackTesting = () => {
    this.setState({
      isPostbackTestingExitModalOpen: false,
    });

    if (this.state.completed) {
      this._resetPolling();
    } else {
      this._stopPolling();
    }
  };

  _executeTimerAction = () => {
    if (this.state.completed) {
      this._resetPolling();
    } else {
      this.setState({
        isPostbackTestingExitModalOpen: true,
      });
    }
  };

  componentWillUnmount() {
    clearInterval(this._poll);
  }

  componentDidMount() {
    const { timerInterval } = this.props;
    this._poll = setInterval(this._getTimerValue, timerInterval);
  }

  render() {
    const { startText, expiredText, stopActionText, restartActionText } = this.props;
    return (
      <div>
        {this.state.isPostbackTestingExitModalOpen && (
          <ModalPostbackTestingExit
            closeModal={this._closeModal}
            closeModalWithStop={this._exitPostbackTesting}
            open={this.state.isPostbackTestingExitModalOpen}
          />
        )}
        <div
          className={classNames('timer__background-box', {
            danger: this.state.completed,
          })}
          data-testid={`timer__background-box-${this.props.testid}`}
        >
          <div className="timer__countdown" data-testid={`timer__countdown-${this.props.testid}`}>
            <svg className="svg__timer-bg" data-testid={`svg__timer-bg-${this.props.testid}`}>
              <circle className="svg__circle-bg-shadow" r="18" cx="26" cy="26" />
              <circle className="svg__circle-bg" r="18" cx="26" cy="26" />
            </svg>
            <svg className="svg__timer" data-testid={`svg__timer-${this.props.testid}`}>
              <circle
                className={classNames('svg__circle-stroke', {
                  danger: this.state.completed,
                })}
                r="18"
                cx="20"
                cy="20"
              />
              <circle
                className={classNames('svg__circle-stroke-bg', {
                  danger: this.state.completed,
                })}
                r="18"
                cx="20"
                cy="20"
              />
            </svg>
            <div
              className="timer__countdown-number-container"
              data-testid={`timer__countdown-number-container-${this.props.testid}`}
            >
              <div className="timer__countdown-number" data-testid={`timer__countdown-number-${this.props.testid}`}>
                {this.state.timeLeft}
              </div>
            </div>
          </div>
          <div className="timer__text" data-testid={`timer__text-${this.props.testid}`}>
            {this.state.completed ? `${expiredText} \n` : `${startText} \n`}
          </div>
          <div className="timer__action-div">
            <Button testid="timer__action" onClick={this._executeTimerAction} type="primary">
              {this.state.completed ? restartActionText : stopActionText}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default Timer;
